var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegisteredPatient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 232,
    height: 117.438,
    viewBox: "0 0 232 117.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38324",
    "data-name": "Group 38324",
    transform: "translate(-323 -430.562)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7111",
    "data-name": "Rectangle 7111",
    width: 232,
    height: 117,
    rx: 5,
    transform: "translate(323 431)",
    fill: "#191bc3",
    opacity: 0.781
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37379",
    "data-name": "Group 37379",
    transform: "translate(0 90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65014",
    "data-name": "Path 65014",
    d: "M2935.331,208s-40.513-16.139-12-47.552S2909.5,90.562,2909.5,90.562h50.79V208Z",
    transform: "translate(-2406 250)",
    fill: "#7bd5fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65015",
    "data-name": "Path 65015",
    d: "M2935.331,208s-40.513-16.139-12-47.552S2909.5,90.562,2909.5,90.562h50.79V208Z",
    transform: "translate(-2416 250)",
    fill: "#7bd5fa",
    opacity: 0.282
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisteredPatient);
export default __webpack_public_path__ + "static/media/RegisteredPatient.b3330a25bf5e7c3345557006d343318e.svg";
export { ForwardRef as ReactComponent };